const locations = [
    { id: 'none', value: '', name: '' },
    { id: 'location-1', value: 'Calgary', name: 'Calgary, Alberta' },
    { id: 'location-2', value: 'Durham Region', name: 'Durham Region' },
    { id: 'location-3', value: 'Kitchener-Waterloo', name: 'Kitchener-Waterloo-Cambridge' },
    { id: 'location-4', value: 'London', name: 'London' },
    { id: 'location-5', value: 'Niagara Region', name: 'Niagara Region' },
    { id: 'location-6', value: 'Ottawa', name: 'Ottawa' },
    { id: 'location-7', value: 'Toronto', name: 'Toronto' },
    { id: 'location-8', value: 'Huronia-Muskoka', name: 'Huronia-Muskoka' },
    { id: 'location-9', value: 'Norfolk County', name: 'Norfolk County' },
    { id: 'location-10', value: 'Sarnia', name: 'Sarnia' },
    { id: 'location-11', value: 'Woodstock', name: 'Woodstock' },
    { id: 'location-12', value: 'York-Simcoe', name: 'York-Simcoe' },
];

export default locations;
